module.exports = __webpack_public_path__ + "static/media/Last2.70ebb20b.jpg";